import type { SVGProps } from 'react';

export const ChatBubble = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m6.05 17.5-2.025 2c-.283.283-.608.35-.975.2-.367-.167-.55-.45-.55-.85V4.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h15.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v11.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H6.05ZM5.4 16h14.3c.067 0 .133-.033.2-.1s.1-.133.1-.2V4.3c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1H4.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v13.075L5.4 16ZM4 16V4v12Z" />
    </svg>
  );
};
